export const ELASTICITY_CHARTS_REQUEST = "ELASTICITY_CHARTS_REQUEST";
export const ELASTICITY_CHARTS_SUCCESS = "ELASTICITY_CHARTS_SUCCESS";
export const ELASTICITY_CHARTS_FAILURE = "ELASTICITY_CHARTS_FAILURE";
